export default __webpack_public_path__ + "static/media/Ana Flávia_.f3e99ecc.png";